import API from "../../api/Api.service";

const login = async (data) => {
  const res = await API.post("/login", data);
  return res.data;
};

const register = async (data) => {
  const res = await API.post("/register", data);
  return res.data;
};

const getVerificationCode = async (data) => {
  const res = await API.post(`/recover_password`, null, {
    params: {
      username: data?.username || data?.email,
    },
  });
  return res.data;
};

const resetUserPassword = async (data) => {
  const res = await API.post(`/reset_password`, data);
  return res.data;
};

const sendVerificationEmail = async (data) => {
  const res = await API.post(`/send_verification_email`, data);
  return res.data;
};

const verifyEmailCode = async (data) => {
  const res = await API.post(`/verify_email_code`, data);
  return res.data;
};

const newPassword = async (data) => {
  const res = await API.post(`/reset_password`, data);
  return res.data;
};

// WEB-01: the backend POST /login/google verifies a Google ID token (`idToken`).
const googleLogin = async (idToken) => {
  const res = await API.post(`/login/google`, { idToken });
  return res.data;
};

const refreshSession = async () => {
  const res = await API.post("/refresh_token", {});
  return res.data;
};

const AuthService = {
  login,
  resetUserPassword,
  getVerificationCode,
  register,
  sendVerificationEmail,
  verifyEmailCode,
  newPassword,
  googleLogin,
  refreshSession,
};

export default AuthService;
